import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  assignGroupsToUserId,
  assignRolesToGroupId,
  assignRolesToUserId,
  createClient,
  deleteGroupById,
  deleteRoleById,
  deleteUserById,
  disableClient,
  downloadUsersByRoleId,
  enableClient,
  exportUsers,
  deleteModelById,
  deleteModuleById,
  deletePermissionById,
  deleteSubModuleById,
  getAllModules,
  getAllModels,
  getAllPermissions,
  getAllSubModules,
  getAssignedRolesByGroupId,
  getAssignedRolesByUserId,
  getClientDetails,
  getClientSecret,
  getGroups,
  getGroupsByUserId,
  getGroupsTree,
  getModels,
  getPermissions,
  getRoleById,
  getRoles,
  getSubGroups,
  getSubModules,
  getUsers,
  getUsersByGroupId,
  getUsersById,
  getUsersByRoleIdOrGroupId,
  postChildGroups,
  postGroups,
  postModel,
  postModule,
  postPermission,
  postSubModule,
  postRoles,
  postUsers,
  putUsersById,
  regenerateClientSecret,
  renameGroups,
  resetUsersPassword,
  savePermissions,
  syncGroups,
  syncRoles,
  unassignGroupsOfUserId,
  unassignRolesOfGroupId,
  unassignRolesOfUserId,
  updateClient,
  updateModelById,
  updateModuleById,
  updatePermissionById,
  updateRoleById,
  updateSubModuleById,
} from "../../services/IAM/Iam_services";

const initialValues = {
  rolesData: [],
  ModuleList: [],
  SubmoduleList: [],
  ModelList: [],
  PermissionList: [],
};

let iamStore = (set) => ({
  ...initialValues,
  getRoles: async (params) => {
    const response = await getRoles(params);
    set({ rolesData: response });
    return response;
  },
  postRoles: async (data) => {
    const response = await postRoles(data);
    return response;
  },
  getRoleById: async (params) => {
    const response = await getRoleById(params);
    return response;
  },
  updateRoleById: async (params, data) => {
    const response = await updateRoleById(params, data);
    return response;
  },
  deleteRoleById: async (params) => {
    const response = await deleteRoleById(params);
    return response;
  },
  syncRoles: async () => {
    const response = await syncRoles();
    return response;
  },
  getUsersByRoleIdOrGroupId: async (params) => {
    const response = await getUsersByRoleIdOrGroupId(params);
    return response;
  },
  getUsersByGroupId: async (params) => {
    const response = await getUsersByGroupId(params);
    return response;
  },
  downloadUsersByRoleId: async (params) => {
    const response = await downloadUsersByRoleId(params);
    return response;
  },
  getGroups: async (params) => {
    const response = await getGroups(params);
    return response;
  },
  getGroupsTree: async () => {
    const response = await getGroupsTree();
    return response;
  },
  postGroups: async (data) => {
    const response = await postGroups(data);
    return response;
  },
  postChildGroups: async (params, data) => {
    const response = await postChildGroups(params, data);
    return response;
  },
  deleteGroupById: async (params) => {
    const response = await deleteGroupById(params);
    return response;
  },
  getGroupsByUserId: async (params) => {
    const response = await getGroupsByUserId(params);
    return response;
  },
  syncGroups: async () => {
    const response = await syncGroups();
    return response;
  },
  getSubGroups: async (params) => {
    const response = await getSubGroups(params);
    return response;
  },
  getUsers: async (params) => {
    const response = await getUsers(params);
    return response;
  },
  postUsers: async (data) => {
    const response = await postUsers(data);
    return response;
  },
  resetUsersPassword: async (data) => {
    const response = await resetUsersPassword(data);
    return response;
  },
  putUsersById: async (params, data) => {
    const response = await putUsersById(params, data);
    return response;
  },
  getUsersById: async (params) => {
    const response = await getUsersById(params);
    return response;
  },
  deleteUserById: async (params) => {
    const response = await deleteUserById(params);
    return response;
  },
  getAssignedRolesUserById: async (params) => {
    const response = await getAssignedRolesByUserId(params);
    return response;
  },
  assignRolesToUserId: async (params1, params2) => {
    const response = await assignRolesToUserId(params1, params2);
    return response;
  },
  unassignRolesOfUserId: async (params1, params2) => {
    const response = await unassignRolesOfUserId(params1, params2);
    return response;
  },
  assignGroupsToUserId: async (params1, params2) => {
    const response = await assignGroupsToUserId(params1, params2);
    return response;
  },
  unassignGroupsOfUserId: async (params1, params2) => {
    const response = await unassignGroupsOfUserId(params1, params2);
    return response;
  },
  unassignRolesOfGroupId: async (params1, params2) => {
    const response = await unassignRolesOfGroupId(params1, params2);
    return response;
  },
  assignRolesToGroupId: async (params1, params2) => {
    const response = await assignRolesToGroupId(params1, params2);
    return response;
  },
  getAssignedRolesByGroupId: async (params) => {
    const response = await getAssignedRolesByGroupId(params);
    return response;
  },
  getAllModules: async () => {
    const response = await getAllModules();
    set({ ModuleList: response });
    return response;
  },
  getSubModules: async (params) => {
    const response = await getSubModules(params);
    set({ SubmoduleList: response });
    return response;
  },
  getModels: async (params) => {
    const response = await getModels(params);
    set({ ModelList: response });
    return response;
  },
  getPermissions: async (params) => {
    const response = await getPermissions(params);
    set({ PermissionList: response });
    return response;
  },
  // Access Setup (module / submodule / model / permission masters).
  getAllSubModules: async () => {
    const response = await getAllSubModules();
    return response;
  },
  getAllModels: async () => {
    const response = await getAllModels();
    return response;
  },
  getAllPermissions: async () => {
    const response = await getAllPermissions();
    return response;
  },
  postModule: async (data) => {
    const response = await postModule(data);
    return response;
  },
  updateModuleById: async (id, data) => {
    const response = await updateModuleById(id, data);
    return response;
  },
  deleteModuleById: async (id) => {
    const response = await deleteModuleById(id);
    return response;
  },
  postSubModule: async (data) => {
    const response = await postSubModule(data);
    return response;
  },
  updateSubModuleById: async (id, data) => {
    const response = await updateSubModuleById(id, data);
    return response;
  },
  deleteSubModuleById: async (id) => {
    const response = await deleteSubModuleById(id);
    return response;
  },
  postModel: async (data) => {
    const response = await postModel(data);
    return response;
  },
  updateModelById: async (id, data) => {
    const response = await updateModelById(id, data);
    return response;
  },
  deleteModelById: async (id) => {
    const response = await deleteModelById(id);
    return response;
  },
  postPermission: async (data) => {
    const response = await postPermission(data);
    return response;
  },
  updatePermissionById: async (id, data) => {
    const response = await updatePermissionById(id, data);
    return response;
  },
  deletePermissionById: async (id) => {
    const response = await deletePermissionById(id);
    return response;
  },
  renameGroups: async (params, data) => {
    const response = await renameGroups(params, data);
    set({ ModelList: response });
    return response;
  },
  exportUsers: async (params) => {
    const response = await exportUsers(params);
    return response;
  },
  createClient: async (data) => {
    const response = await createClient(data);
    return response;
  },
  updateClient: async (clientId, data) => {
    const response = await updateClient(clientId, data);
    return response;
  },
  getClientDetails: async (clientId) => {
    const response = await getClientDetails(clientId);
    return response;
  },
  enableClient: async (clientId) => {
    const response = await enableClient(clientId);
    return response;
  },
  disableClient: async (clientId) => {
    const response = await disableClient(clientId);
    return response;
  },
  regenerateClientSecret: async (clientId) => {
    const response = await regenerateClientSecret(clientId);
    return response;
  },
  getClientSecret: async (clientId) => {
    const response = await getClientSecret(clientId);
    return response;
  },
  savePermissions: async (clientId, data) => {
    const response = await savePermissions(clientId, data);
    return response;
  },
});

iamStore = devtools(iamStore);

export const useIamStore = create(iamStore);
